import { render, staticRenderFns } from "./DrawerOrderHistory.vue?vue&type=template&id=aa6d9bae&scoped=true&"
import script from "./DrawerOrderHistory.vue?vue&type=script&lang=js&"
export * from "./DrawerOrderHistory.vue?vue&type=script&lang=js&"
import style0 from "./DrawerOrderHistory.vue?vue&type=style&index=0&id=aa6d9bae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6d9bae",
  null
  
)

export default component.exports